
export const QUERY_REQUEST = "QUERY_REQUEST";
export const QUERY_SUCCESS = "QUERY_SUCCESS";
export const QUERY_RESET = "QUERY_RESET";
export const QUERY_FAIL = "QUERY_FAIL";
export const CLEAR_ERROR = "CLEAR_ERROR"

export const ALL_QUERY_REQUEST = "ALL_QUERY_REQUEST";
export const ALL_QUERY_SUCCESS = "ALL_QUERY_SUCCESS";
export const ALL_QUERY_FAIL = "ALL_QUERY_FAIL";
export const ALL_QUERY_RESET = "ALL_QUERY_RESET";

export const QUERY_DETAILS_REQUEST = "QUERY_DETAILS_REQUEST";
export const QUERY_DETAILS_SUCCESS = "QUERY_DETAILS_SUCCESS";
export const QUERY_DETAILS_FAIL = "QUERY_DETAILS_FAIL";


export const UPDATE_QUERY_REQUEST = "UPDATE_QUERY_REQUEST";
export const UPDATE_QUERY_SUCCESS = "UPDATE_QUERY_SUCCESS";
export const UPDATE_QUERY_FAIL = "UPDATE_QUERY_FAIL";
export const UPDATE_QUERY_RESET = "UPDATE_QUERY_RESET";

export const DELETE_QUERY_REQUEST = "DELETE_QUERY_REQUEST";
export const DELETE_QUERY_SUCCESS = "DELETE_QUERY_SUCCESS";
export const DELETE_QUERY_FAIL = "DELETE_QUERY_FAIL";
export const DELETE_QUERY_RESET = "DELETE_QUERY_RESET";